import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import { getJobs } from '../../../services/jobsService';

const DesignerDashboard = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getJobs();
        setJobs(data?.jobs || []);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <LoadingSpinner />;

  const statusCount = jobs.reduce((acc, j) => {
    acc[j.status] = (acc[j.status] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Designer Dashboard</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {Object.entries(statusCount).map(([k, v]) => (
          <div key={k} className="card p-6">
            <div className="text-gray-500 text-sm">{k}</div>
            <div className="text-2xl font-semibold">{v}</div>
          </div>
        ))}
      </div>
      <div className="card p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Assigned Jobs</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Job ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {jobs.map(j => (
                <tr key={j._id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{j.jobId}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{j.customer?.name}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{j.status}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-right">
                    <Link to={`/jobs/${j._id}`} className="text-primary-600 hover:text-primary-800">View</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DesignerDashboard;
